// /src/toolkitServices/purityApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const purityApi = createApi({
  reducerPath: "purityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL, // e.g. http://localhost:4000/api
    credentials: "include",
  }),
  tagTypes: ["Purity"],
  endpoints: (builder) => ({
    // CREATE  POST /api/purities/create
    addPurity: builder.mutation({
      query: (payload) => ({
        url: "/purities/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Purity"],
    }),

    // LIST    GET /api/purities?page=&limit=&q=&active=&category=
    getAllPurities: builder.query({
      query: ({ page = 1, limit = 1000, search = "", active, category } = {}) => {
        const params = { page, limit, q: search };
        if (typeof active === "boolean") params.active = active; // true/false
        if (category) params.category = category;               // id or name
        return { url: "/purities", params };
      },
      providesTags: ["Purity"],
    }),

    // GET ONE GET /api/purities/:id
    getPurityById: builder.query({
      query: (id) => `/purities/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Purity", id }],
    }),

    // UPDATE  PUT /api/purities/:id
    updatePurity: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/purities/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Purity"],
    }),

    // DELETE  DELETE /api/purities/:id
    deletePurity: builder.mutation({
      query: (id) => ({
        url: `/purities/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Purity"],
    }),

    // ACTIVATE / DEACTIVATE
    activatePurity: builder.mutation({
      query: (id) => ({
        url: `/purities/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Purity"],
    }),
    deactivatePurity: builder.mutation({
      query: (id) => ({
        url: `/purities/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Purity"],
    }),
  }),
});

export const {
  useAddPurityMutation,
  useGetAllPuritiesQuery,
  useGetPurityByIdQuery,
  useUpdatePurityMutation,
  useDeletePurityMutation,
  useActivatePurityMutation,
  useDeactivatePurityMutation,
} = purityApi;

export default purityApi;
